import { useT } from '../i18n/LanguageProvider';
import type { ServiceArea } from '../types/content';

interface Props {
  service: ServiceArea;
}

export default function ServiceBlock({ service }: Props) {
  const t = useT();

  return (
    <section className="service" id={service.id}>
      <div>
        <div className="eyebrow">{service.num}</div>
        <h2>{service.title}</h2>
        <p className="problem-line">{service.problem}</p>
      </div>
      <div>
        <p className="lead">{service.summary}</p>
        <div className="service-grid">
          <div>
            <h4>{t.serviceBlock.what}</h4>
            <ul>
              {service.what.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </div>
          <div>
            <h4>{t.serviceBlock.how}</h4>
            <ul>
              {service.how.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </div>
        </div>
        <div className="outcome">
          <strong>{t.serviceBlock.outcome}</strong>
          <span>{service.outcome}</span>
        </div>
      </div>
    </section>
  );
}
